// extracted by mini-css-extract-plugin
module.exports = {"mainscreen":"Intro_mainscreen__1zvlN","link":"Intro_link__1RQO9"};